<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
<path :fill="fill" d="M50 41.188a19.03 19.03 0 0 0 19.031-19.031A19.03 19.03 0 0 0 50 3.126a19.03 19.03 0 0 0-19.031 19.03A19.03 19.03 0 0 0 50 41.189m0-31.812c5.168 0 9.828 3.113 11.809 7.89a12.79 12.79 0 0 1-2.77 13.93 12.784 12.784 0 0 1-21.82-9.04c0-7.058 5.723-12.78 12.78-12.78zM55.969 46.875H44.031a32.998 32.998 0 0 0-32.937 32.969 17.07 17.07 0 0 0 4.996 12.035 17.07 17.07 0 0 0 12.035 4.996h43.75a17.07 17.07 0 0 0 12.035-4.996 17.07 17.07 0 0 0 4.996-12.035 33 33 0 0 0-32.937-32.969zm15.906 43.75h-43.75c-5.945-.016-10.766-4.836-10.781-10.781a26.718 26.718 0 0 1 26.687-26.719H55.97a26.72 26.72 0 0 1 26.688 26.719c-.016 5.945-4.836 10.766-10.781 10.781z"/>
</svg>
</template>

<script setup>
	const props = defineProps({
	  fill: {
	    type: String,
	    default: 'currentColor'
	  }
	})
</script>